import React, { useContext } from 'react';
import styles from './styles.module.css';
import SyntaxHighlighter from '../../components/SyntaxHighlighter'
import { customGradientPie, data, focusPie, focusPieSectionsData, sectionAutoFocusPie } from './data';
import ProTip from '../../components/ProTip';
import { AppContext } from '../../AppContext';
import { appConstants } from '../../constants';

const lineStyle={marginLeft:-20,fontSize:16,color:'gray'}
export const headers = {
    minimal: { id: "minimal", label: "Minimal Pie chart" },
    styling: { id: "styling", label: "Styling the chart" },
    donut: { id: "donut", label: "Donut Charts" },
    threed: { id: "three-d", label: "Three D charts" },
    shadow: { id: "shadow", label: "Shadow effects" },
    shifInnerCenter: { id: "shift-inner-center", label: "Shift Inner center" },
    gradient: { id: "gradient", label: "Gradient" },
    splitPie: { id: "split-pie", label: "Split Pie sections" },
    focusOnPress: { id: "focus-onpress", label: "Focus pie section on Press" },
    sectionAutoFocus: { id: "section-auto-focus", label: "sectionAutoFocus" },
    centerLabel: { id: "center-Label", label: "Center Label Component" },
    onpress: { id: "onpress", label: "onPress and onLabelPress" },
    legend: { id: "legend", label: "Custom Legend Component" },
  };
export const MainBody=props=>{
    const { isMobile, onBodyScroll } = props;
    const appContext = useContext(AppContext);
    const { width, theme } = appContext;
    const { sideDrawerWidth, rightNavWidth } = appConstants;
  
    const isSideDrawerVisible = width > 1100;
  
    const mainBodyWidth = isMobile
      ? width
      : width - rightNavWidth - (isSideDrawerVisible ? sideDrawerWidth - 10 : 30)
  
    return(
        <div
            className={styles.container}
            style={{ paddingLeft: isMobile ? 3 : 20, width: mainBodyWidth }}
            onScroll={onBodyScroll}
        >
            <h2>
                Pie Charts
                <a style={{marginLeft:20,fontSize:15, color: theme==='dark'? 'skyblue' : 'blue'}} target="_blank" href='https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts/blob/master/docs/PieChart/PieChartProps.md' rel="noreferrer">
                    props table
                </a>
            </h2>
            <div style={{marginLeft:10,marginBottom:100}}>
                <h4 id={headers.minimal.id}>
                    Minimal Pie Chart
                </h4>
                <div style={{marginLeft:10}}>
                    The simplest Pie chart can be made with just-
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[0].code}
                    </SyntaxHighlighter>
                    <h5>Output-</h5>
                    <img
                    src={data[0].imgSrc}
                    className={styles.barOutput}
                    alt=''/>
                </div>

                <h4 id={headers.styling.id}>
                    Styling the Chart
                </h4>
                <div style={{marginLeft:10}}>
                    <p>
                        By default, the pie chart sections will take random colors. (Not actually random, but from a pre-defined list of colors)<br/>
                        To change the colors, we can send <b>color</b> property along with the <b>value</b> in the data array
                    </p>
                    <p>Let's try making the below Pie chart</p>
                    <img
                    src={data[1].imgSrc}
                    className={styles.barOutput}
                    alt=''/>
                    <p>
                        Props we will use to make the above chart-
                        <ul>
                            <li>
                                <b>color </b>sent with each item of the data array to set the color of the particular Pie section
                            </li>
                            <li>
                                <b>text </b>sent with each item of the data array to set the label text of the particular Pie section
                            </li>
                            <li>
                                <b>radius </b> to set the radius of the Pie chart
                            </li>
                            <li>
                                <b>textColor </b>to set the color of the label text, if this prop is not passed, the label for each Pie section gets a random color
                            </li>
                            <li>
                                <b>textSize </b>to set the color of the label text
                            </li>
                            <li>
                                <b>showTextBackground </b>to show background for each label, the background shape is circular by default
                            </li>
                            <li>
                                <b>textBackgroundRadius </b>radius of the background of the label text
                            </li>
                        </ul>
                    </p>
                    <p>The new code after adding these props-</p>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[1].code}
                    </SyntaxHighlighter>
                </div>

                <hr/>
                <br/>
                
                <h2 id={headers.donut.id}>
                    Donut Charts-
                </h2>
                <div style={{marginLeft:10}}>
                    <ProTip
                    body={()=>{return(<>You can convert any pie chart into donut chart by just passing the <b>donut</b> prop to the {'<PieChart/>'} component.</>)}}/>

                    <p>
                        The result after adding the <b>donut</b> prop to the above code is-
                    </p>
                    <img
                    src={require('../../assets/donut.png')}
                    className={styles.barOutput}
                    alt=''/>
                </div>

                <h4 id={headers.threed.id}>
                    Three D charts-
                </h4>
                <div style={{marginLeft:10}}>
                    <p>
                        Passing the <b>isThreeD</b> prop to any Pie chart gives it a 3 dimensional effect.<br/>
                        Here is the code for a 3-D donut chart-
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[3].code}
                    </SyntaxHighlighter>
                    <h5>Output-</h5>
                    <img
                    src={data[3].imgSrc}
                    className={styles.threedoutput}
                    alt=''/>
                </div>
                <hr/>
                <br/>

                <h4 id={headers.shadow.id}>
                    Shadow effects-
                </h4>
                <div style={{marginLeft:10}}>
                    <p>
                        The above donut chart doesn't really feel like three dimensional, let's try adding a shadow.
                    </p>
                    <img
                    src={require('../../assets/donutShadow.png')}
                    className={styles.threedoutput}
                    alt=''/>
                    <p>
                        The props related to shadow are-
                    </p>
                    <ul>
                        <li>
                            shadowColor
                        </li>
                        <li>
                            strokeWidth
                        </li>
                    </ul>
                </div>

                <h4>
                    innerCircleBorderWidth and innerCircleBorderColor-
                </h4>
                <div style={{marginLeft:10}}>
                    <p>
                        A combination of shadow, innerCircleBorderWidth and innerCircleBorderColor gives a near to real 3D effect
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[4].code}
                    </SyntaxHighlighter>
                    <h5>Output-</h5>
                    <img
                    src={data[4].imgSrc}
                    className={styles.threedoutput}
                    alt=''/>
                </div>
                <h4 id={headers.shifInnerCenter.id}>
                    Shift Inner center 
                </h4>
                <div style={{marginLeft:10}}>
                    <p>
                        To make the chart even more close to 3D, we can shift the center of inner circle in the donut chart<br/>
                        The props used for this are- <b>shiftInnerCenterX</b> and <b>shiftInnerCenterY</b>
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[5].code}
                    </SyntaxHighlighter>
                    <h5>Output-</h5>
                    <img
                    src={data[5].imgSrc}
                    className={styles.threedoutput}
                    alt=''/>
                </div>

                <hr/>
                <br/>

                <h4 id={headers.gradient.id}>
                    Gradient-
                </h4>
                <div style={{marginLeft:10}}>
                    <p>
                        Radial Gradient can be applied by just passing the <b>showGradient</b> prop. The simplest example is-
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[6].code}
                    </SyntaxHighlighter>
                    <p>
                        The result of the above code is-
                    </p>
                    <img
                    src={data[6].imgSrc}
                    className={styles.barOutput}
                    alt=''/>
                    <p>
                        The default color at the centre is <b><i>white</i></b>. It can be changed using the <b>gradientCenterColor</b> prop.<br/>
                        <b>gradientCenterColor</b> can also be passed separately for each data item inside the data array.<br/>
                        Here is an example of a showing how to set custom gradient colors for each section-
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {customGradientPie}
                    </SyntaxHighlighter>
                    <img
                    src={'https://user-images.githubusercontent.com/20596944/169662692-f701900b-8efe-4b5e-9cd1-47128651de5f.png'}
                    className={styles.barOutput}
                    alt=''/>
                    <p>
                        The above Pie chart with gradient doesn't look appealing. Here's another one with some modifications-
                    </p>
                    <img
                    src={data[7].imgSrc}
                    className={styles.barOutput}
                    alt=''/>
                    <p>
                        The code for the above chart is-
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[7].code}
                    </SyntaxHighlighter>
                </div>

                <hr/>
                <br/>

                <h4 id={headers.splitPie.id}>
                    Split Pie sections-
                </h4>
                <div style={{marginLeft:10}}>
                    <p>
                        You can split specific pie sections, by using the <b>shiftX</b> and <b>shiftY</b> props in the data array
                    </p>
                    <img
                    src={data[2].imgSrc}
                    className={styles.barOutput}
                    alt=''/>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[2].code}
                    </SyntaxHighlighter>
                </div>

                <hr/>
                <br/>

                <h3 id={headers.focusOnPress.id}>
                    Focus pie section on Press
                </h3>
                <div style={{marginLeft:10}}>
                    <p>
                        Most Pie and donut charts have this feature where the pie section gets bigger and highlighted when it is pressed. An example is shown below-
                    </p>
                    <img
                        src={'https://user-images.githubusercontent.com/20596944/170603008-1a5628f0-61fa-4e5b-b9dd-d673f9ae21d3.gif'}
                        className={styles.outputBig}
                        alt=''/>
                    <p>
                        To achieve this you just need to pass the <b>focusOnPress</b> prop.
                    </p>
                    <p>
                        When a pie section is focused, its radius is increased by 10% of the chart's radius. The increase in radius of the focused section can be controlled using the <b>extraRadiusForFocused</b> prop.<br/>
                        Also, by default the focus gets toggled on consecutive presses of the same pie section. This can be stopped by setting the prop <b>toggleFocusOnPress</b> to <b>false</b> (its default value is true).
                    </p>
                    <p>
                        The code for the above chart is-
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {focusPieSectionsData}
                    </SyntaxHighlighter>
                    <p>
                    When a pie section is focused, its radius is increased by 10% of the chart's radius.
                    The increase in radius of the focused section can be controlled using the <b>extraRadiusForFocused</b> prop.<br/>
                    Also, by default the focus gets toggled on consecutive presses of the same pie section.
                    This can be stopped by setting the prop <b>toggleFocusOnPress</b> to false (its default value is true).
                    </p>
                    <p>
                        Similarly, the "Focus on press" feature can be applied to Donut and 3D charts also. 
                    </p>
                    <h3 id={headers.sectionAutoFocus.id}>
                        sectionAutoFocus
                    </h3>
                    <p>
                        In some charts you may want to autofocus one of the pie sections. After that you may or may not want to enable focusOnPress.<br/>
                        Let's discuss both the cases separately-
                        <ol>
                            <li>
                                <b>autofocus and enable focusOnPress: </b>
                                If you want <b>focusOnPress</b> enabled, and also want to autofocus one of the pie sections, just add the property <b><i>focused: true</i></b> to the data object of that pie section in the data array.
                            </li>
                            <li>
                                <b>autofocus and disable focusOnPress: </b>
                                If you want <b>focusOnPress</b> disabled, but want to autofocus one of the pie sections, you need to add the property <b><i>focused: true</i></b> to the data object of that pie section in the data array.<b> And also</b> add the prop <b>sectionAutoFocus</b> to the PieChart component.
                                <p>
                                    Here's an example of a Pie chart using <b>sectionAutoFocus</b>
                                </p>
                                <img
                                    src={'https://github.com/Abhinandan-Kushwaha/chart-images/blob/main/screenshots/sectionAutoFocus.png?raw=true'}
                                    style={{borderRadius:20, width: 360}}
                                    alt=''/>
                                <p>
                                    The code for the above chart is-
                                </p>
                                <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                                    {sectionAutoFocusPie}
                                </SyntaxHighlighter>
                            </li>
                        </ol>
                    </p>
                </div>

                <hr/>
                <br/>

                <h4 id={headers.centerLabel.id}>
                    Center Label Component
                </h4>
                <div style={{marginLeft:10}}>
                    <p>
                        Sometimes you may want to display some label text at the center of the Pie or Donut chart<br/>
                        For this, you can pass a your own component through the <b>centerLabelComponent</b> prop. Here's an example-
                    </p>
                    <img
                    src={data[8].imgSrc}
                    className={styles.barOutput}
                    alt=''/>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[8].code}
                    </SyntaxHighlighter>
                </div>
                <hr/>
                <br/>

                <h4 id={headers.onpress.id}>
                    onPress and onLabelPress
                </h4>
                <div style={{marginLeft:10}}>
                    <p>
                        <b>onPress</b> prop takes a callback function with 2 parameters- item and index. Here's an example-
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {`onPress = { (item, index) => Alert.alert(item.value.toString() ) }`}
                    </SyntaxHighlighter>
                    <p>
                        onPress can also be passed separately for each data item inside the data array.
                    </p>
                    <p>
                        Exactly similar to onPress, we have another prop named onLabelPress. As the name suggests, this function is called when a label is pressed.
                    </p>
                </div>
                <hr/>
                <br/>

                <h4 id={headers.legend.id}>
                    Custom Legend Component
                </h4>
                <div style={{marginLeft:10}}>
                    <p>
                        Pie charts most often need a Legend to tell the viewers what different section of the chart represent.<br/><br/>
                        Currently, we don't have any in-built function to render the Legend. This is because, the Legend component varies quite a lot as per UI requirements, and also it's very easy to make one yourself.<br/><br/>
                        You can easily make your own. Here's an example-
                    </p>
                    <img
                    src={data[9].imgSrc}
                    className={styles.threedoutput}
                    style={{borderRadius:12}}
                    alt=''/>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[9].code}
                    </SyntaxHighlighter>
                </div>
                <hr/>
                <br/>
            </div>
        </div>
    );
}